'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:ui:confirm');
}

var _invoke = require('../invoke');

/**
 * 双按钮弹窗，类似 confirm
 *
 * 支持版本
 * + iHotel/5.8+
 *
 * @memberof ui
 * @static
 * @name confirm
 * @param {String} message 弹窗信息
 * @param {String} [title] 弹窗标题，可选
 * @param {Object} leftButton 左按钮
 * @param {Object} rightButton 右按钮
 * @return {Undefined}
 * @example
 *  hbnb.ui.confirm('message', 'title', {
 *      label: '确定',
 *      callback: function() {}
 *  }, {
 *      label: '取消',
 *      callback: function() {}
 *  });
 */
module.exports = function(message, title, leftButton, rightButton) {
    if (process.env.NODE_ENV !== 'production') {
        debug('message is %j', message);
        debug('title is %j', title);
        debug('left button is %j', leftButton);
        debug('right button is %j', rightButton);
    }

    if (!rightButton) {
        rightButton = leftButton;
        leftButton = title;
        title = '';
    }

    _invoke('ui', 'alert', {
        message: message,
        title: title,
        buttons: [leftButton, rightButton]
    });
};



//////////////////
// WEBPACK FOOTER
// ./~/@hfe/hbnb/ui/confirm.js
// module id = 646
// module chunks = 0